var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizer7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 332,
    viewBox: "0 0 332 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-334 -172)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 332,
    rx: 20,
    transform: "translate(666 504) rotate(180)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 504) rotate(180)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(550 504) rotate(180)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 504) rotate(180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 272) rotate(180)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(550 272) rotate(180)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 272) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(434 388) rotate(180)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(550 388) rotate(180)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "translate(666 388) rotate(180)",
    fill: "#fff",
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizer7);
export default __webpack_public_path__ + "static/media/visualizer-7.57cf423bf7dcfaa7e8ee44aab6ebbc5c.svg";
export { ForwardRef as ReactComponent };